// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"e806d957","453":"5b41ed8d"}[chunkId] + ".chunk.js";
};